/*
 * Copyright (C) 2024 - present Cohota, Inc.
 *
 * This file is part of Cohota.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import Bridge from '../../../bridge';
export default function (ed, document) {
  return import('./components/Embed').then(_ref => {
    let {
      Embed
    } = _ref;
    let container = document.querySelector('.canvas-rce-embed-container');

    if (!container) {
      container = document.createElement('div');
      container.className = 'canvas-rce-embed-container';
      document.body.appendChild(container);
    }

    const handleDismiss = () => {
      ReactDOM.unmountComponentAtNode(container);
      ed.focus(false);
    };

    const handleEmbedCode = embedCode => {
      Bridge.insertEmbedCode(embedCode);
    };

    ReactDOM.render( /*#__PURE__*/React.createElement(Embed, {
      onSubmit: handleEmbedCode,
      onDismiss: handleDismiss
    }), container);
  });
}